import {
  createBackgroundReq,
  getUpdatedDetailsReq,
} from "../../../../redux/specialist-slices/auth.slice";
import { Box, Button, Icon, Stack, Typography } from "@mui/material";
import InputField1 from "../../../../components/ui/InputField1";
import FileInput from "../../../../components/ui/FileInput";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../../assets/js/Icons";
import { useToast } from "../../../../hooks/useToast";
import { useEffect, useState } from "react";
import { red } from "@mui/material/colors";
import { useRef } from "react";
import moment from "moment";
function Details({ handleChange }) {
  const dispatch = useDispatch();
  const toast = useToast();
  const [errors, setErrors] = useState({});
  const { specialist } = useSelector((state) => state.specialistSlice);

  const files = useRef({
    personalIdentification:
      specialist?.background?.personalIdentification || [],
    professionalIdentification:
      specialist?.background?.professionalIdentification || [],
  });

  // Handle add experties
  const handleSubmit = (e) => {
    e.preventDefault();
    const err = {};
    const form = new FormData(e.target);
    let formData = Object.fromEntries(form);
    formData = {
      ...files.current,
      ...formData,
    };
    formData.fullName = specialist?.specialist?.fullName;
    Object.keys(formData)?.forEach((field) => {
      const value = formData[field];
      if (Array.isArray(value)) {
        if (!value?.length) {
          err[field] = true;
        } else {
          delete err[field];
        }
      } else {
        if (typeof value === "string" && (value?.trim() === "" || !value)) {
          err[field] = true;
        } else {
          delete err?.[field];
        }
      }
    });

    if (formData.dob) {
      const age = moment().diff(moment(formData.dob), "years");
      if (age < 21) {
        err.dob = "You must be at least 21 years old";
      }
    }

    setErrors(err);
    if (!Object.keys(err)?.length) {
      toast.success("Expertise data updated successfully!");

      dispatch(createBackgroundReq(formData))
        .unwrap()
        .then(() => {
          handleChange("profile");
        })
        .catch(() => {});
    }
  };

  useEffect(() => {
    dispatch(getUpdatedDetailsReq());
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #3498db",
        borderTop: "none",
        borderRadius: "0 0 6px 6px",
      }}
    >
      <Typography
        mb={2}
        fontSize={36}
        component="h2"
        fontWeight="700"
        color="other.color1"
      >
        Ensuring Trust and Safety
      </Typography>
      <Typography
        mb={1.7}
        fontSize={24}
        component="h4"
        fontWeight="600"
        color="other.color1"
      >
        Complete Your Background Check
      </Typography>
      <Typography mb={2} fontWeight="500" color="other.color2">
        To maintain the highest standards of trust and safety on our platform,
        we require all specialists to complete a background check. Please
        provide the necessary documents and information below. Rest assured,
        your personal information is handled with the utmost confidentiality and
        security
      </Typography>
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <Box>
          <InputField1
            type="text"
            name="fullName"
            label="Full Name *"
            placeholder="Full Name"
            value={specialist?.specialist?.fullName}
            disabled
          />
          {errors?.fullName && (
            <Typography mt={1} color={red["500"]}>
              Please enter full name
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            name="dob"
            type="date"
            label="Date of Birth *"
            placeholder="DD/MM"
            endIcon={
              <Icon sx={{ fontSize: "18px" }}>
                <Icons.CalendarSolid />
              </Icon>
            }
            slotProps={{ inputProps: { max: moment().subtract(21, "years").format("YYYY-MM-DD") } }}
            defaultValue={
              specialist?.background?.dob
                ? moment(specialist?.background?.dob).format("YYYY-MM-DD")
                : ""
            }
          />
          {errors?.dob && (
            <Typography mt={1} color={red["500"]}>
              {typeof errors.dob === "string" ? errors.dob : "Please enter Date of Birth"}
            </Typography>
          )}
        </Box>
        <FileInput
          files={files}
          errors={errors}
          name="personalIdentification"
          label="Personal Identification *"
          errText="Please Upload Personal Identification"
          defaultValue={specialist?.background?.personalIdentification || []}
          placeholderText="Upload Personal Identification (e.g., Passport, Driver's License)"
        />
        <FileInput
          files={files}
          errors={errors}
          name="professionalIdentification"
          label="Professional Identification *"
          errText="Please Upload Professional Identification"
          defaultValue={
            specialist?.background?.professionalIdentification || []
          }
          placeholderText="Upload Professional Identification (e.g., Passport, Driver's License)"
        />
        <Stack spacing={2} direction="row">
          <Button
            sx={{
              py: 1.2,
              minWidth: "110px",
              justifyContent: "center",
            }}
            type="button"
            variant="contained"
            onClick={async () => {
              await dispatch(getUpdatedDetailsReq());
              handleChange("expertise");
            }}
          >
            Back
          </Button>
          <Button
            sx={{
              py: 1.2,
              minWidth: "110px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Details;
